export enum ApprovalRuleType {
  /** All approve */
  AllApprove = 'all_approve',
  /** Any one approval */
  AnyOneApprove = 'any_one_approve',
  /** Majority approves */
  MajorityApprove = 'majority_approve',
}
